import moment from 'moment'

const MONTHS = {
  JANUARY: {
    key: 'JANUARY',
    start: (year = new Date().getFullYear()) =>
      moment(`01/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`01/01/${year}`).endOf('month'),
    name: 'January',
    abbr: 'Jan',
  },
  FEBRUARY: {
    key: 'FEBRUARY',
    start: (year = new Date().getFullYear()) =>
      moment(`02/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`02/01/${year}`).endOf('month'),
    name: 'February',
    abbr: 'Feb',
  },
  MARCH: {
    key: 'MARCH',
    start: (year = new Date().getFullYear()) =>
      moment(`03/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`03/01/${year}`).endOf('month'),
    name: 'March',
    abbr: 'Mar',
  },
  APRIL: {
    key: 'APRIL',
    start: (year = new Date().getFullYear()) =>
      moment(`04/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`04/01/${year}`).endOf('month'),
    name: 'April',
    abbr: 'Apr',
  },
  MAY: {
    key: 'MAY',
    start: (year = new Date().getFullYear()) =>
      moment(`05/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`05/01/${year}`).endOf('month'),
    name: 'May',
    abbr: 'May',
  },
  JUNE: {
    key: 'JUNE',
    start: (year = new Date().getFullYear()) =>
      moment(`06/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`06/01/${year}`).endOf('month'),
    name: 'June',
    abbr: 'Jun',
  },
  JULY: {
    key: 'JULY',
    start: (year = new Date().getFullYear()) =>
      moment(`07/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`07/01/${year}`).endOf('month'),
    name: 'July',
    abbr: 'Jul',
  },
  AUGUST: {
    key: 'AUGUST',
    start: (year = new Date().getFullYear()) =>
      moment(`08/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`08/01/${year}`).endOf('month'),
    name: 'August',
    abbr: 'Aug',
  },
  SEPTEMBER: {
    key: 'SEPTEMBER',
    start: (year = new Date().getFullYear()) =>
      moment(`09/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`09/01/${year}`).endOf('month'),
    name: 'September',
    abbr: 'Sep',
  },
  OCTOBER: {
    key: 'OCTOBER',
    start: (year = new Date().getFullYear()) =>
      moment(`10/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`10/01/${year}`).endOf('month'),
    name: 'October',
    abbr: 'Oct',
  },
  NOVEMBER: {
    key: 'NOVEMBER',
    start: (year = new Date().getFullYear()) =>
      moment(`11/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`11/01/${year}`).endOf('month'),
    name: 'November',
    abbr: 'Nov',
  },
  DECEMBER: {
    key: 'DECEMBER',
    start: (year = new Date().getFullYear()) =>
      moment(`12/01/${year}`).startOf('month'),
    end: (year = new Date().getFullYear()) =>
      moment(`12/01/${year}`).endOf('month'),
    name: 'December',
    abbr: 'Dec',
  },
}

export default MONTHS
